<template>
  <div class="swiper-component">
    <div class="swiper-pagination" v-if="viewMode === 'slider'" />
    <div class="swiper-navigation" v-if="viewMode === 'slider'">
      <div class="swiper-button-prev" />
      <div class="swiper-button-next" />
    </div>
    <Swiper
        v-if="viewMode === 'slider'"
        :modules="modules"
        :slides-per-view="'auto'"
        :space-between="40"
        :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }"
        :breakpoints="{ 768: { centeredSlides: false } }"
        :centered-slides="true"
        style="padding: 25px 0; cursor: grab;"
    >
      <SwiperSlide v-for="item in options" :key="item.id" style="width: auto;" @click="handleSelect(item)">
        <PopupCard :active-item="activeItem.value" :item="item" />
      </SwiperSlide>
    </Swiper>
    <div
        v-else-if="viewMode === 'grid'"
        class="grid-view"
    >
      <div v-for="item in options" :key="item.id" class="grid-item" @click="handleSelect(item)">
        <PopupCardPoses :active-item="activeItem.value" :item="item" />
      </div>
    </div>
    <div
        v-else-if="viewMode === 'grid-full-size'"
        class="grid-full-size-view"
    >
      <div v-for="item in options" :key="item.id" class="grid-item" @click="handleSelect(item)">
        <PopupCard :active-item="activeItem.value" :item="item" />
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation, Pagination } from "swiper";
import PopupCard from "@/components/filter/PopupCard.vue";
import PopupCardPoses from "@/components/filter/PopupCardPoses.vue";
import { computed, ref, onMounted, onUnmounted } from "vue";

export default {
  name: "SwiperComponent",
  components: { PopupCardPoses, PopupCard, Swiper, SwiperSlide },
  props: {
    options: Array,
    activeItem: [Number, String],
    currentStep: { type: Object, default: {} },
    mobileThreshold: { type: Number, default: 768 },
  },
  emits: ["select-item"],
  setup(props, { emit }) {
    const handleSelect = (item) => emit("select-item", item);

    const windowWidth = ref(window.innerWidth);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    const viewMode = computed(() => {
      const stepViewMode = props.currentStep && props.currentStep.viewMode;
      const isMobileOrTablet = windowWidth.value <= 768;
      if (stepViewMode) {
        if (isMobileOrTablet && (stepViewMode === "grid" || stepViewMode === "grid-full-size")) {
          return "slider";
        }
        return stepViewMode;
      }
      return "slider";
    });

    return { handleSelect, viewMode, modules: [Navigation, Pagination] };
  },


};
</script>

<style lang="scss" scoped>
.swiper-component {
  position: relative;

  .swiper-navigation {
    .swiper-button-prev,
    .swiper-button-next {
      &:after { font-size: inherit; }
    }

    .swiper-button-prev {
      left: var(--swiper-navigation-sides-offset, 10px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      width: 43px;
      height: 43px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #acf601;
      color: #000;
      font-size: 25px !important;
    }
    .swiper-button-next {
      right: var(--swiper-navigation-sides-offset, 10px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 3;
      width: 43px;
      height: 43px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #acf601;
      color: #000;
      font-size: 25px !important;
    }
  }
  .grid {
    &-view {
      display: grid;
      place-items: center;
      gap: 20px; padding: 25px 0;
      grid-template-columns: repeat(4, 1fr);
    }

    &-full-size-view {
      display: grid;
      place-items: center;
      gap: 20px;
      padding: 25px 0;
      grid-template-columns: repeat(auto-fit, minmax(min-content, 250px));
      justify-content: center;
    }

    &-item {
      width: auto;
      cursor: pointer;
    }
  }
}
</style>